import { Loader } from '@mantine/core';

const Load = ({size,color,variant}) => {
    return <Loader size={size}  color={color ?? "pink"} variant={variant ?? "oval"}/>;
}

export default Load